<template>
  <div class="container-table saltopagina">
    <q-card-section>
      <q-table
        :data="objetivosRelacionados"
        title="Objetivos relacionados"
        :columns="columns"
        row-key="id"
        :pagination.sync="pagination"
        :loading="isLoading"
        binary-state-sort
      >
        <template v-slot:body-cell-objetivoEstrategico="props">
          <q-td key="objetivoEstrategico" :props="props">
            <q-img
              :src="getImgObjetivo(props.row.objetivoEstrategico.file)"
              :alt="getImgObjetivo(props.row.objetivoEstrategico.file).url"
              height="40px"
              width="40px"
            >
              <q-tooltip anchor="bottom middle" :offset="[0, 10]">
                <strong>{{props.row.objetivoEstrategico.name}}</strong>
              </q-tooltip>
            </q-img>
          </q-td>
        </template>

        <template v-slot:body-cell-objetivoEspecifico="props">
          <q-td key="objetivoEspecifico" :props="props">
            {{props.row.objetivoEspecifico.name}}
          </q-td>
        </template>
        <template v-slot:body-cell-lineasDeActuacion="props">
          <q-td key="lineasDeActuacion" :props="props">
            <div class="divLinea" v-for="linea in props.row.lineasDeActuacion" v-bind:key="linea.id">
              {{ linea.name }}
            </div>
          </q-td>
        </template>
      </q-table>
    </q-card-section>
  </div>
</template>
<script>
import { QTable, QTd, QImg } from 'quasar';
import { mapGetters } from 'vuex';
import Resources from '@/components/shared/mixins/Resources.js';

export default {
  components: {
    QTable,
    QTd,
    QImg
  },
  mixins: [Resources],
  props: {
    isLoading: Boolean,
    objetivosRelacionados: Array,
    styleCard: {
      type: String,
      default: () => 'margin: 20px;'
    }
  },
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData'
    })
  },
  data () {
    return {
      pagination: {
        rowsPerPage: 4
      },
      columns: [
        {
          name: 'objetivoEstrategico',
          label: 'Objetivo estratégico',
          align: 'left',
          field: 'objetivoEstrategico',
          sortable: false
        },
        {
          name: 'objetivoEspecifico',
          label: 'Objetivo Específico',
          align: 'left',
          field: 'objetivoEspecifico',
          sortable: true,
          sort: (a, b) => this.ordenaObjetivoEspecifico(a, b)
        },
        {
          name: 'lineasDeActuacion',
          label: 'Lineas de actuación',
          align: 'left',
          field: 'lineasDeActuacion',
          sortable: true,
          style: 'max-width: 950px',
          sort: (a, b) => this.ordenaLineas(a, b)
        }
      ]
    };
  },
  methods: {
    getImgObjetivo (file) {
      let res = this.searchResource(file, 'imagen');
      return res ? res.url : this.getDefaultResource('imagen');
    },
    ordenaLineas (a, b) {
      return (a[0].name).localeCompare(b[0].name);
    },
    ordenaObjetivoEspecifico (a, b) {
      let firstPartitionA = a.name.split('.');
      let firstPartitionB = b.name.split('.');
      let num1a = parseInt(firstPartitionA[0]);
      let num1b = parseInt(firstPartitionB[0]);
      let secondPartitionA = firstPartitionA[1].split('.');
      let secondPartitionB = firstPartitionB[1].split('.');
      let num2a = parseInt(secondPartitionA[0]);
      let num2b = parseInt(secondPartitionB[0]);
      let textA = secondPartitionA[1];
      let textB = secondPartitionB[1];
      if (num1a === num1b) {
        if (num2a === num2b) {
          return textA - textB;
        } else {
          return num2a - num2b;
        }
      } else {
        return num1a - num1b;
      }
    }

  }
};
</script>
<style lang="scss" scoped>
.header {
  padding-top: 18px;
  .titleDetalle{
    font-family: DINPro;
    font-weight: bold;
    align-content: center;
    display: flex;
    color: #454545;
  }
  #title-card-authorization {
    font-family: DINPro;
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: $azulcabecera;
    display: flex;
    align-items: center;
  }
}
.icon {
  margin-right: 10px;
  font-size: 25px;
}
.iconDetalle {
  margin-right: 10px;
  font-size: 35px;
}
.container-table {
  &::v-deep {
    .q-table__card {
      box-shadow: none;
    }
     .q-table--no-wrap td {
      white-space: normal;
    }

    .q-card__section--vert {
      padding: 0 !important;
      border: solid 3px #e9f4f6;
      border-radius: 12px;
    }
  }
}
.divLinea{
  padding-bottom: 5px;
  padding-top: 5px;
}
</style>
